import(/* webpackMode: "eager" */ "/layers/google.nodejs.yarn/yarn_modules/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Nunito\",\"arguments\":[{\"variable\":\"--font-sans\",\"weight\":\"variable\",\"subsets\":[\"latin\"]}],\"variableName\":\"sansFont\"}");
;
import(/* webpackMode: "eager" */ "/layers/google.nodejs.yarn/yarn_modules/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Big_Shoulders\",\"arguments\":[{\"variable\":\"--font-heading\",\"weight\":\"800\",\"subsets\":[\"latin\"],\"adjustFontFallback\":false}],\"variableName\":\"headingFont\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/app/DrawerPortal.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/workspace/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/components/Navbar.tsx");
